// 模板提示词中用 <u>…</u> 标记需要用户按新素材调整的内容。
// 标记只用于展示：用户侧解析为下划线样式，提交生成时取纯文本，不会带上标记。

export const PROMPT_UNDERLINE_OPEN = "<u>"
export const PROMPT_UNDERLINE_CLOSE = "</u>"

const TAG_PATTERN = /<\/?u>/g

type ParsedPrompt = {
  text: string
  // 每个字符是否带下划线
  flags: boolean[]
}

const parse = (value: string): ParsedPrompt => {
  let text = ""
  const flags: boolean[] = []
  let underline = false
  let end = 0
  const append = (from: number, to: number) => {
    for (let index = from; index < to; index++) {
      text += value[index]
      flags.push(underline)
    }
  }
  for (const match of value.matchAll(TAG_PATTERN)) {
    append(end, match.index)
    underline = match[0] === PROMPT_UNDERLINE_OPEN
    end = match.index + match[0].length
  }
  append(end, value.length)
  return { text, flags }
}

/** 按逐字符的下划线标记生成带 <u>…</u> 的原文。 */
export const formatPromptUnderline = (text: string, flags: boolean[]) => {
  let value = ""
  let underline = false
  for (let index = 0; index < text.length; index++) {
    if (flags[index] !== underline) {
      value += flags[index] ? PROMPT_UNDERLINE_OPEN : PROMPT_UNDERLINE_CLOSE
      underline = flags[index]
    }
    value += text[index]
  }
  return underline ? value + PROMPT_UNDERLINE_CLOSE : value
}

export type PromptUnderlineSegment = { text: string; underline: boolean }

/** 拆分为连续的带 / 不带下划线片段，供编辑器构建文档时使用。 */
export const splitPromptUnderline = (
  value: string,
): PromptUnderlineSegment[] => {
  const { text, flags } = parse(value)
  const segments: PromptUnderlineSegment[] = []
  for (let index = 0; index < text.length; index++) {
    const last = segments.at(-1)
    if (last && last.underline === flags[index]) last.text += text[index]
    else segments.push({ text: text[index], underline: flags[index] })
  }
  return segments
}
